import client from '@/lib/http-client';

const endpoint = '/subscription';

export default {
	request(params, cb, errorCb) {
		const url = `${endpoint}/request`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
